/* ==========================================================================
   MP — Footer
   --------------------------------------------------------------------------
   Companion to sections/mp-footer.liquid and assets/mp-footer.css.

   Does three small things and nothing else:

     1. Reveals the oversized wordmark when it scrolls into view. Pure CSS
        transitions do the animation; this only flips the class that starts
        them, once, and never takes it back.
     2. Reads the build stamp back out of the CSS custom property and logs it,
        so a stale CDN copy is one console line away from being obvious rather
        than an afternoon of "but I pushed that".
     3. Re-initialises after a theme-editor section reload.

   No layout is measured here and no style is written here. If the footer ever
   needs JS to place something, that is a sign the CSS got it wrong.
   ========================================================================== */

(function () {
	'use strict';

	var REVEALED = 'is-revealed';
	var stamped = false;

	function reduceMotion() {
		return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function reveal(root) {
		if (root.classList.contains(REVEALED)) return;
		root.classList.add(REVEALED);
	}

	function initReveal(root) {
		var mode = root.getAttribute('data-reveal') || 'none';

		/* Watch the CROP BOX, not the artwork.
		   The artwork is deliberately taller and wider than the crop and starts
		   the animation translated 200px down, so most of its box is outside the
		   page for as long as the animation has not run. Observing it means a
		   15% threshold can never be met at the bottom of the page and the
		   wordmark stays at opacity 0 forever. The crop box is the thing the
		   visitor can actually see. */
		var wordmark = root.querySelector('.mp-footer__wordmark') ||
			root.querySelector('.mp-footer__wordmark-art');

		/* Nothing to animate, or the visitor asked for no motion: land it at
		   rest immediately so the wordmark is never left at opacity 0. */
		if (mode === 'none' || !wordmark || reduceMotion() || !('IntersectionObserver' in window)) {
			reveal(root);
			return;
		}

		var threshold = parseFloat(root.getAttribute('data-reveal-threshold'));
		if (!(threshold >= 0 && threshold <= 1)) threshold = 0.15;

		var observer = new IntersectionObserver(
			function (entries) {
				for (var i = 0; i < entries.length; i++) {
					if (entries[i].isIntersecting) {
						reveal(root);
						observer.disconnect();
						return;
					}
				}
			},
			{ threshold: threshold }
		);

		observer.observe(wordmark);

		/* A footer that is already in view on load (a short page, or a deep
		   link to an anchor near the bottom) would otherwise wait for a scroll
		   that never comes. IntersectionObserver fires on observe() for that
		   case, but only once layout has settled — this is the belt. */
		window.setTimeout(function () {
			var box = wordmark.getBoundingClientRect();
			if (box.top < (window.innerHeight || 0) && box.bottom > 0) {
				reveal(root);
				observer.disconnect();
			}
		}, 600);
	}

	function stamp(root) {
		if (stamped) return;
		stamped = true;
		var build = getComputedStyle(root).getPropertyValue('--mp-footer-build').trim();
		if (build) console.log('[mp-footer] build ' + build);
	}

	function init(scope) {
		var roots = (scope || document).querySelectorAll('.mp-footer');
		for (var i = 0; i < roots.length; i++) {
			if (roots[i].hasAttribute('data-mp-footer-ready')) continue;
			roots[i].setAttribute('data-mp-footer-ready', '');
			stamp(roots[i]);
			initReveal(roots[i]);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}

	/* Theme editor: the section is replaced wholesale, so the new copy has no
	   ready flag and simply initialises. */
	document.addEventListener('shopify:section:load', function (event) {
		stamped = false;
		init(event.target);
	});
})();
